import { loadableWithFallback } from '@vision/ui/utils';
import type { TrendChart1Props } from './TrendChart1';

export const TrendChart1 = loadableWithFallback<TrendChart1Props>(() => import('./TrendChart1'));
